// eslint-disable-next-line css-modules/no-unused-class
import { FieldValuesType, FormValueType } from '../../hooks/useFormValues';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './FormFields.module.css';
import { Select } from './Select';

type FormSelectParams<T> = {
	setValues: (value: FormValueType<T>) => void;
	id: string;
	field?: FieldValuesType<string | string[]>;
	label: string;
	multiple?: boolean;
	options: {
		[key: string]: string;
	};
};

export function FormSelectBox<T>({ setValues, id, field, label, options, multiple }: FormSelectParams<T>) {
	return (
		<div className={styles.fieldContainer}>
			<Select
				id={id}
				multiple={multiple}
				placeholder={label}
				label={label}
				value={field?.value}
				name={id}
				options={options}
				onChange={e => {
					setValues({
						[id]: e.target.value
					} as FormValueType<T>);
				}}
				errors={field?.errors && field.errors.length > 0 ? field.errors : []}
			/>
		</div>
	);
}
